/* eslint-disable no-use-before-define, no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import { getItem } from '@Utils/LocalStorage';
import { USER_STATE_LOCAL_STORAGE_KEY, USER_REDUCER_NAME } from './Constants';

const initialState = getItem(USER_STATE_LOCAL_STORAGE_KEY) || {
  isLoggedIn: false,
  accessToken: null,
  user: {},
};

export const userSlice = createSlice({
  name: USER_REDUCER_NAME,
  initialState,
  reducers: {
    setLoggedIn: (state, { payload: { isLoggedIn, accessToken } }) => {
      state.isLoggedIn = isLoggedIn;
      state.accessToken = accessToken;
    },

    setUserInfo: (state, { payload: { user } }) => {
      state.user = user;
    },

    removeAllUserState: () => {
      return initialState;
    },
  },
});

const { setLoggedIn, setUserInfo, removeAllUserState } = userSlice.actions;

export { setLoggedIn, setUserInfo, removeAllUserState };

export default userSlice.reducer;
